import React, { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import {
//   MaterialReactTable,
//   useMaterialReactTable,
// } from "material-react-table";
import {
  useMaterialReactTable,
  MRT_ToggleFiltersButton,
  MRT_ShowHideColumnsButton,
  MRT_TableContainer,
} from 'material-react-table';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { API_URL } from "../../env";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { useDispatch, useSelector } from "react-redux";
import { fetchDataStockRep } from "../../Redux/ReportsData/StockReportDataSlice";

import dayjs from "dayjs";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { InputLabel } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { format, parse } from "date-fns";
import { enGB } from "date-fns/locale";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsLeftRight } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import { Box } from "@mui/material";
config.autoAddCss = false;
const fontAwesomeIcons = {
  DragHandleIcon: () => (
    <FontAwesomeIcon
      icon={faArrowsLeftRight}
      style={{ paddingLeft: "5px", fontSize: "14px", color: "white" }}
    />
  ),
};

const CalculationTypeList = [
  {
    label: "Standard Cost",
    value: 1
  },
  {
    label: "Average Cost",
    value: 2
  },
  {
    label: "Last Purchase Cost",
    value: 3
  },
  {
    label: "FIFO",
    value: 4
  },
]

export default function StockQuickSummary() {
  const Theme = useSelector((state) => state.Theme);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const { result, status, error } = useSelector(
    (state) => state.StockReportData
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ids } = useParams();
  const idsArr = ids.split("-");
  const calId = idsArr[0];
  const dgId = idsArr[1];
  const unitId = idsArr[2];

  const [StockReportData, setStockReportData] = useState([]);
  const [MergedData, setMergedData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [IsWithAmount, setIsWithAmount] = useState(false);
  const [CalculationType, setCalculationType] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleExport = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const exportToExcel = (rows) => {
    let ReorderedColumns = table
      .getState()
      .columnOrder?.map((columnId) => table.getColumn(columnId)?.columnDef);

    const tableData = rows?.map((row) =>
      Object.values(
        ReorderedColumns?.filter((item) => columnVisibility[item?.id]).reduce(
          (acc, c) => {
            if (c.id?.includes("Date")) {
              acc[c.id] =
                new Date(row.original[c.id])?.toLocaleDateString("en-GB") ==
                  "01/01/1"
                  ? ""
                  : new Date(row.original[c.id])?.toLocaleDateString("en-GB");
            } else {
              acc[c.id] = row.original[c.id];
            }
            return acc;
          },
          {}
        )
      )
    );
    const tableHeaders = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => c.header);

    const tableRows = tableData?.map((row) =>
      row?.map((value) => value).join(",")
    );

    const csvData = [tableHeaders.join(","), ...tableRows].join("\n");

    const blob = new Blob([csvData], { type: "text/csv" });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    if (calId > 0) {
      a.download = `Stock_Quick_Summary-(${CalculationTypeList?.filter((el) => el?.value == calId)[0]?.label}).csv`;
    } else {
      a.download = "Stock_Quick_Summary.csv";
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportToPDF = (rows) => {
    const doc = new jsPDF({
      orientation: "landscape",
    });
    var xOffset = doc.internal.pageSize.width / 2;
    doc.setFontSize(12);
    doc.text(cmpdetail?.CompanyName, xOffset, 8, { align: "center" });
    doc.setFontSize(10);
    if (calId > 0) {
      doc.text(`Stock Quick Summary - (${CalculationTypeList?.filter((el) => el?.value == calId)[0]?.label})`, xOffset, 12, { align: "center" });
    } else {
      doc.text("Stock Quick Summary", xOffset, 12, { align: "center" });
    }

    let ReorderedColumns = table
      .getState()
      .columnOrder?.map((columnId) => table.getColumn(columnId)?.columnDef);

    const tableData = rows?.map((row) =>
      Object.values(
        ReorderedColumns?.filter((item) => columnVisibility[item?.id]).reduce(
          (acc, c) => {
            if (c.id?.includes("Date")) {
              acc[c.id] =
                new Date(row.original[c.id])?.toLocaleDateString("en-GB") ==
                  "01/01/1"
                  ? ""
                  : new Date(row.original[c.id])?.toLocaleDateString("en-GB");
            } else {
              acc[c.id] = row.original[c.id];
            }
            return acc;
          },
          {}
        )
      )
    );
    const tableHeaders = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) => c.header);
    const tableFootersQty = ReorderedColumns?.filter(
      (item) => columnVisibility[item?.id]
    )?.map((c) =>
      c?.Footer?.()?.props.children[0]?.props?.children
        ? c?.Footer?.()?.props.children[0]?.props?.children
        : ""
    );
    // const tableFootersMtrs = ReorderedColumns?.filter(
    //   (item) => columnVisibility[item?.id]
    // )?.map((c) =>
    //   c?.Footer?.()?.props.children[2]?.props?.children
    //     ? c?.Footer?.()?.props.children[2]?.props?.children
    //     : ""
    // );

    autoTable(doc, {
      head: [tableHeaders],
      body: tableData,
      // foot: [tableFootersQty, tableFootersMtrs],
      foot: [tableFootersQty],
      showHead: "firstPage",
      showFoot: "lastPage",
      theme: "striped",
      columnStyles: {
        text: { cellWidth: "auto" },
      },
      margin: {
        left: 3,
        right: 3,
      },
      styles: {
        overflow: "linebreak",
        cellWidth: "wrap",
        cellPadding: 1,
        fontSize: 6,
      },
      autoWidth: true,
    });

    doc.save("Stock_Quick_Summary.pdf");
  };

  const exportToJson = () => {
    const json = CustomStringify(FilteredData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Stock_Quick_Summary.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  const [columnVisibility, setColumnVisibility] = useState({
    DesignGroupName: true,
    DesignName: true,
    ProductName: true,
    ColourName: false,
    SizeName: false,
    Sd_VNo: false,
    Sd_VDate: false,
    Sd_BillNo: false,
    Sd_BillDate: false,
    LedgerName: false,
    // BarcodeNo: false,
    Sd_VType: false,
    DepartmentName: true,
    LocationName: false,
    PatternName: true,
    UnitName: true,
    Opening: true,
    Inward: true,
    Outward: true,
    Balance: true,
    Sd_RateBFT: false,
    // Sd_Rate: false,
    Sd_AmountBFT: false,
    // Sd_Amount: false,
    CategoryCodeName: false,
    Sd_LPRate: false,
    Sourcing: false,
    // Sd_Remark: false,
    // Sd_EntryDate: false,
    // Sd_ModifiedDate: false,
    // sd_lastStockLastInDate: false,
    // Sd_AmountBFT_ToT: false,
    // Sd_Amount_ToT: false,
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);

  const columns = [
    {
      accessorKey: "DesignGroupName",
      header: "DesignGroup",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              Total Qty :{" "}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              Total MTRs :{" "}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "DesignName",
      header: "Design",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "ProductName",
      header: "Product",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "ColourName",
      header: "Colour",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "SizeName",
      header: "Size",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Sd_VNo",
      header: "V. No.",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorFn: (originalRow) => new Date(originalRow.Sd_VDate),
      id: "Sd_VDate",
      header: "Date",
      size: 50,
      filterFn: (row, columnId, filterValue) => {
        const { startDate, endDate } = filterValue;

        return startDate && !endDate
          ? row.getValue(columnId) >= startDate
          : !startDate && endDate
            ? row.getValue(columnId) <= endDate
            : startDate && endDate
              ? row.getValue(columnId) >= startDate &&
              row.getValue(columnId) <= endDate
              : row.getValue(columnId);
      },
      Filter: ({ column, table }) => {
        const handleFilterChange = (startDate, endDate) => {
          table.setColumnFilters([
            {
              id: column.id,
              value: {
                startDate: startDate ? dayjs(startDate) : null,
                endDate: endDate ? dayjs(endDate) : null,
              },
            },
          ]);
        };

        return (
          <ThemeProvider theme={form}>
            <LocalizationProvider dateAdapter={AdapterDayjs} locale={enGB}>
              <div style={{ display: "flex", gap: "1rem" }}>
                <DatePicker
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { placeholder: "Start Date" } }}
                  value={column.getFilterValue()?.startDate}
                  onChange={(newValue) =>
                    handleFilterChange(
                      newValue.format("YYYY-MM-DD"),
                      column.getFilterValue()?.endDate
                    )
                  }
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { placeholder: "End Date" } }}
                  value={column.getFilterValue()?.endDate}
                  onChange={(newValue) =>
                    handleFilterChange(
                      column.getFilterValue()?.startDate,
                      newValue.format("YYYY-MM-DD")
                    )
                  }
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
            </LocalizationProvider>
          </ThemeProvider>
        );
      },
      Cell: ({ cell }) =>
        cell.getValue().toLocaleDateString("en-GB") == "01/01/1"
          ? ""
          : cell.getValue().toLocaleDateString("en-GB"),
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Sd_BillNo",
      header: "Bill No.",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorFn: (originalRow) => new Date(originalRow.Sd_BillDate),
      id: "Sd_BillDate",
      header: "Bill Date",
      size: 50,
      filterFn: (row, columnId, filterValue) => {
        const { startDate, endDate } = filterValue;

        return startDate && !endDate
          ? row.getValue(columnId) >= startDate
          : !startDate && endDate
            ? row.getValue(columnId) <= endDate
            : startDate && endDate
              ? row.getValue(columnId) >= startDate &&
              row.getValue(columnId) <= endDate
              : row.getValue(columnId);
      },
      Filter: ({ column, table }) => {
        const handleFilterChange = (startDate, endDate) => {
          table.setColumnFilters([
            {
              id: column.id,
              value: {
                startDate: startDate ? dayjs(startDate) : null,
                endDate: endDate ? dayjs(endDate) : null,
              },
            },
          ]);
        };

        return (
          <ThemeProvider theme={form}>
            <LocalizationProvider dateAdapter={AdapterDayjs} locale={enGB}>
              <div style={{ display: "flex", gap: "1rem" }}>
                <DatePicker
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { placeholder: "Start Date" } }}
                  value={column.getFilterValue()?.startDate}
                  onChange={(newValue) =>
                    handleFilterChange(
                      newValue.format("YYYY-MM-DD"),
                      column.getFilterValue()?.endDate
                    )
                  }
                  renderInput={(params) => <TextField {...params} />}
                />
                <DatePicker
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { placeholder: "End Date" } }}
                  value={column.getFilterValue()?.endDate}
                  onChange={(newValue) =>
                    handleFilterChange(
                      column.getFilterValue()?.startDate,
                      newValue.format("YYYY-MM-DD")
                    )
                  }
                  renderInput={(params) => <TextField {...params} />}
                />
              </div>
            </LocalizationProvider>
          </ThemeProvider>
        );
      },
      Cell: ({ cell }) =>
        cell.getValue().toLocaleDateString("en-GB") == "01/01/1"
          ? ""
          : cell.getValue().toLocaleDateString("en-GB"),
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "LedgerName",
      header: "Ledger",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    // {
    //   accessorKey: 'BarcodeNo',
    //   header: 'Barcode',
    //   size: 50,
    // },
    {
      accessorKey: "Sd_VType",
      header: "V. Type",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "DepartmentName",
      header: "Department",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "LocationName",
      header: "Location",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "PatternName",
      header: "Pattern",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "UnitName",
      header: "Unit",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Opening",
      header: "Opening",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + item.Opening, 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Opening, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Inward",
      header: "Inward",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + item.Inward, 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Inward, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Outward",
      header: "Outward",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + item.Outward, 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Outward, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Balance",
      header: "Balance",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + item.Balance, 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Balance, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Sd_RateBFT",
      header: "Rate",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    // {
    //   accessorKey: "Sd_Rate",
    //   header: "Rate",
    //   size: 50,
    //   Footer: () => {
    //     return (
    //       <div style={{ display: "flex", flexDirection: "column" }}>
    //         <span
    //           style={{
    //             fontSize: "15px",
    //             fontWeight: "bold",
    //             padding: "3px 5px 3px 5px",
    //           }}
    //         >
    //           &nbsp;
    //         </span>
    //         <hr style={{ margin: 0, opacity: 0.9 }} />
    //         <span
    //           style={{
    //             fontSize: "15px",
    //             fontWeight: "bold",
    //             padding: "3px 5px 3px 5px",
    //           }}
    //         >
    //           &nbsp;
    //         </span>
    //       </div>
    //     );
    //   },
    // },
    {
      accessorKey: "Sd_AmountBFT",
      header: "Amount",
      size: 50,
      Footer: () => {
        const TotValueQty = FilteredData?.reduce((acc, item) => acc + item.Sd_AmountBFT, 0);
        // const TotValueMtrs = FilteredData?.filter(
        //   (item) => item?.UnitName == "MTRs"
        // ).reduce((acc, item) => acc + item.Sd_AmountBFT, 0);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueQty?.toFixed(2)}
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              {TotValueMtrs?.toFixed(2)}
            </span> */}
          </div>
        );
      },
    },
    // {
    //   accessorKey: "Sd_Amount",
    //   header: "Amount",
    //   size: 50,
    //   Footer: () => {
    //     const TotValueQty = FilteredData?.filter(
    //       (item) => item?.UnitName == "Pcs"
    //     ).reduce((acc, item) => acc + item.Sd_Amount, 0);
    //     const TotValueMtrs = FilteredData?.filter(
    //       (item) => item?.UnitName == "MTRs"
    //     ).reduce((acc, item) => acc + item.Sd_Amount, 0);
    //     return (
    //       <div style={{ display: "flex", flexDirection: "column" }}>
    //         <span
    //           style={{
    //             fontSize: "15px",
    //             fontWeight: "bold",
    //             padding: "3px 5px 3px 5px",
    //           }}
    //         >
    //           {TotValueQty?.toFixed(2)}
    //         </span>
    //         <hr style={{ margin: 0, opacity: 0.9 }} />
    //         <span
    //           style={{
    //             fontSize: "15px",
    //             fontWeight: "bold",
    //             padding: "3px 5px 3px 5px",
    //           }}
    //         >
    //           {TotValueMtrs?.toFixed(2)}
    //         </span>
    //       </div>
    //     );
    //   },
    // },
    {
      accessorKey: "CategoryCodeName",
      header: "Category",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Sd_LPRate",
      header: "LPRate",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    {
      accessorKey: "Sourcing",
      header: "Sourcing",
      size: 50,
      Footer: () => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span>
            {/* <hr style={{ margin: 0, opacity: 0.9 }} />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                padding: "3px 5px 3px 5px",
              }}
            >
              &nbsp;
            </span> */}
          </div>
        );
      },
    },
    // {
    //   accessorKey: 'Sd_Remark',
    //   header: 'Remark',
    //   size: 50,
    // },
    // {
    //   accessorFn: (originalRow) => new Date(originalRow.Sd_EntryDate),
    //   id: 'Sd_EntryDate',
    //   header: 'Entry Date',
    //   filterVariant: 'date-range',
    //   size: 50,
    //   filterFn: (row, columnId, filterValue) => {
    //   const startDate = filterValue[0];
    //   const endDate = filterValue[1];
    //   return (startDate && !endDate) ? row.getValue(columnId) >= startDate : (!startDate && endDate) ? row.getValue(columnId) <= endDate :
    //     (startDate && endDate) ? row.getValue(columnId) >= startDate && row.getValue(columnId) <= endDate : row.getValue(columnId);
    // },
    //   Cell: ({ cell }) => cell.getValue().toLocaleDateString('en-GB') == "01/01/1" ? "" : cell.getValue().toLocaleDateString('en-GB'),
    // },
    // {
    //   accessorFn: (originalRow) => new Date(originalRow.Sd_ModifiedDate),
    //   id: 'Sd_ModifiedDate',
    //   header: 'Modified Date',
    //   filterVariant: 'date-range',
    //   size: 50,
    //   filterFn: (row, columnId, filterValue) => {
    //   const startDate = filterValue[0];
    //   const endDate = filterValue[1];
    //   return (startDate && !endDate) ? row.getValue(columnId) >= startDate : (!startDate && endDate) ? row.getValue(columnId) <= endDate :
    //     (startDate && endDate) ? row.getValue(columnId) >= startDate && row.getValue(columnId) <= endDate : row.getValue(columnId);
    // },
    //   Cell: ({ cell }) => cell.getValue().toLocaleDateString('en-GB') == "01/01/1" ? "" : cell.getValue().toLocaleDateString('en-GB'),
    // },
    // {
    //   accessorFn: (originalRow) => new Date(originalRow.sd_lastStockLastInDate),
    //   id: 'sd_lastStockLastInDate',
    //   header: 'Last Stock In Date',
    //   filterVariant: 'date-range',
    //   size: 50,
    //   filterFn: (row, columnId, filterValue) => {
    //   const startDate = filterValue[0];
    //   const endDate = filterValue[1];
    //   return (startDate && !endDate) ? row.getValue(columnId) >= startDate : (!startDate && endDate) ? row.getValue(columnId) <= endDate :
    //     (startDate && endDate) ? row.getValue(columnId) >= startDate && row.getValue(columnId) <= endDate : row.getValue(columnId);
    // },
    //   Cell: ({ cell }) => cell.getValue().toLocaleDateString('en-GB') == "01/01/1" ? "" : cell.getValue().toLocaleDateString('en-GB'),
    // },
    // {
    //   accessorKey: 'Sd_AmountBFT_ToT',
    //   header: 'Tot. Amount BFT',
    //   size: 50,
    //   Footer: () => {
    //     const TotValue = FilteredData.reduce((acc, item) => acc + item.Sd_AmountBFT_ToT, 0);
    //     return <span style={{ fontSize: "15px", fontWeight: "bold" }}>{TotValue?.toFixed(2)}</span>;
    //   },
    // },
    // {
    //   accessorKey: 'Sd_Amount_ToT',
    //   header: 'Tot. Amount',
    //   size: 50,
    //   Footer: () => {
    //     const TotValue = FilteredData.reduce((acc, item) => acc + item.Sd_Amount_ToT, 0);
    //     return <span style={{ fontSize: "15px", fontWeight: "bold" }}>{TotValue?.toFixed(2)}</span>;
    //   },
    // },
  ];


  const data = MergedData;

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        navigate(`/StockSummary/${calId}-${row?.original?.Sd_DesignGroupID}-${row?.original?.UnitName}-${row?.original?.Sd_DesignID}-${row?.original?.Sd_ProductID}-${row?.original?.Sd_DepartmentId}-${row?.original?.Sd_PatternId}`);
      },
      sx: {
        cursor: "pointer", //you might want to change the cursor too when adding an onClick
      },
    }),
    icons: fontAwesomeIcons,
    enableColumnOrdering: true,
    enableBottomToolbar: false,
    enablePagination: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    // columnFilterDisplayMode: 'popover',
    enableSorting: false,
    enableGlobalFilter: false,
    initialState: { density: "compact" },
    muiTableContainerProps: {
      sx: {
        maxHeight: `calc(${"100vh"} - ${"100px"})`,
        "@media (max-width: 768px)": {
          maxHeight: `calc(${"100vh"} - ${"140px"})`,
        },
        "@media (max-width: 530px)": {
          maxHeight: `calc(${"100vh"} - ${"180px"})`,
        },
      }
    },
    muiTableHeadCellProps: {
      sx: {
        bgcolor: Theme.primaryThemeColor,
        color: "#fff",
        "@media (max-width: 768px)": {
          padding: "2px 16px"
        },
      },
    },
    muiTableBodyCellProps: {
      sx: {
        opacity: 0.9,
        border: "1px solid grey",
        "@media (max-width: 768px)": {
          fontSize: "13px",
          padding: "2px 16px"
        },
      },
    },
    muiTableFooterCellProps: {
      sx: {
        bgcolor: Theme.primaryThemeColor,
        color: "#fff",
        padding: 0,
      },
    },
    muiColumnActionsButtonProps: {
      sx: {
        color: "#fff",
      },
    },
    muiFilterTextFieldProps: {
      placeholder: "Filter",
      sx: {
        background: "#fff",
        borderRadius: "5px",
        padding: "0px 3px",
      },
    },
    state: { columnVisibility, columnOrder, columnFilters },
    onColumnVisibilityChange: (state) => {
      return setColumnVisibility(state);
    },
    onColumnOrderChange: (state) => {
      return setColumnOrder(state);
    },
    onColumnFiltersChange: (state) => {
      return setColumnFilters(state);
    }
  });

  useEffect(() => {
    const mergedArray = StockReportData.reduce((accumulator, current) => {
      const existing = accumulator.find(
        (item) =>
          (columnVisibility.DesignName
            ? item.DesignName === current.DesignName
            : true) &&
          (columnVisibility.ProductName
            ? item.ProductName === current.ProductName
            : true) &&
          (columnVisibility.ColourName
            ? item.ColourName === current.ColourName
            : true) &&
          (columnVisibility.SizeName
            ? item.SizeName === current.SizeName
            : true) &&
          (columnVisibility.Sd_VNo ? item.Sd_VNo === current.Sd_VNo : true) &&
          (columnVisibility.Sd_VDate
            ? item.Sd_VDate === current.Sd_VDate
            : true) &&
          (columnVisibility.Sd_BillNo
            ? item.Sd_BillNo === current.Sd_BillNo
            : true) &&
          (columnVisibility.Sd_BillDate
            ? item.Sd_BillDate === current.Sd_BillDate
            : true) &&
          (columnVisibility.LedgerName
            ? item.LedgerName === current.LedgerName
            : true) &&
          // && (columnVisibility.BarcodeNo ? item.BarcodeNo === current.BarcodeNo : true)
          (columnVisibility.Sd_VType
            ? item.Sd_VType === current.Sd_VType
            : true) &&
          (columnVisibility.UnitName
            ? item.UnitName === current.UnitName
            : true) &&
          (columnVisibility.Sd_RateBFT
            ? item.Sd_RateBFT === current.Sd_RateBFT
            : true) &&
          // (columnVisibility.Sd_Rate
          //   ? item.Sd_Rate === current.Sd_Rate
          //   : true) &&
          (columnVisibility.DepartmentName
            ? item.DepartmentName === current.DepartmentName
            : true) &&
          (columnVisibility.LocationName
            ? item.LocationName === current.LocationName
            : true) &&
          (columnVisibility.PatternName
            ? item.PatternName === current.PatternName
            : true) &&
          (columnVisibility.DesignGroupName
            ? item.DesignGroupName === current.DesignGroupName
            : true) &&
          (columnVisibility.CategoryCodeName
            ? item.CategoryCodeName === current.CategoryCodeName
            : true) &&
          (columnVisibility.Sd_LPRate
            ? item.Sd_LPRate === current.Sd_LPRate
            : true) &&
          (columnVisibility.Sourcing
            ? item.Sourcing === current.Sourcing
            : true)
        // && (columnVisibility.Sd_Remark ? item.Sd_Remark === current.Sd_Remark : true)
        // && (columnVisibility.Sd_EntryDate ? item.Sd_EntryDate === current.Sd_EntryDate : true)
        // && (columnVisibility.Sd_ModifiedDate ? item.Sd_ModifiedDate === current.Sd_ModifiedDate : true)
        // && (columnVisibility.sd_lastStockLastInDate ? item.sd_lastStockLastInDate === current.sd_lastStockLastInDate : true)
      );

      if (existing) {
        existing.Opening += current.Opening;
        existing.Inward += current.Inward;
        existing.Outward += current.Outward;
        existing.Balance += current.Balance;
        existing.Sd_AmountBFT += current.Sd_AmountBFT;
        // existing.Sd_Amount += current.Sd_Amount;
        // existing.Sd_AmountBFT_ToT += current.Sd_AmountBFT_ToT;
        // existing.Sd_Amount_ToT += current.Sd_Amount_ToT;
      } else {
        accumulator.push({ ...current });
      }

      return accumulator;
    }, []);

    setMergedData(mergedArray);
  }, [columnVisibility, StockReportData]);

  useEffect(() => {
    const filteredRows = table.getFilteredRowModel().rows;
    const filteredData = filteredRows?.map((row) => row.original);
    setFilteredData(filteredData);
  }, [columnFilters, StockReportData]);

  useEffect(() => {
    let Data = result?.data?.map((item) => {
      return {
        ...item,
        // Opening:
        //   item?.Sd_VNature == "OPENING"
        //     ? item?.UnitName == "Pcs"
        //       ? Number(item?.Sd_Qty)
        //       : Number(item?.Sd_Mtrs)
        //     : 0,
        // Inward:
        //   item?.Sd_VNature == "InWord"
        //     ? item?.UnitName == "Pcs"
        //       ? Number(item?.Sd_Qty)
        //       : Number(item?.Sd_Mtrs)
        //     : 0,
        // Outward:
        //   item?.Sd_VNature == "OutWord"
        //     ? item?.UnitName == "Pcs"
        //       ? Number(item?.Sd_Qty)
        //       : Number(item?.Sd_Mtrs)
        //     : 0,
        Opening:
          item?.Sd_VNature == "OPENING"
            ? Number(item?.Sd_Qty)
            : 0,
        Inward:
          item?.Sd_VNature == "InWord"
            ? Number(item?.Sd_Qty)
            : 0,
        Outward:
          item?.Sd_VNature == "OutWord"
            ? Number(item?.Sd_Qty)
            : 0,
      };
    });
    Data = Data?.map((item) => {
      return {
        ...item,
        Balance:
          Number(item?.Opening) +
          Number(item?.Inward) -
          Number(item?.Outward),
      };
    });
    setStockReportData(Data?.filter((item) => item?.Sd_DesignGroupID == dgId && item?.UnitName == unitId));
    setMergedData(Data?.filter((item) => item?.Sd_DesignGroupID == dgId && item?.UnitName == unitId));
    setFilteredData(Data?.filter((item) => item?.Sd_DesignGroupID == dgId && item?.UnitName == unitId));
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h4: {
        fontWeight: "500",
        fontSize: "20px",
        "@media (max-width: 768px)": {
          fontSize: "16px",
        },
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            maxWidth: "260px",
            height: "28px",
            padding: "12px 8px 12px 8px",
            fontWeight: 500,
            "@media (max-width: 768px)": {
              fontSize: "11px",
              padding: "10px 5px 10px 5px",
            },
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            fontSize: "15px",
            "@media (max-width: 768px)": {
              fontSize: "13px",
            },
          },
        },
      },
    },
  });

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "15px",
            height: "32px",
            width: "150px",
            background: "#fff",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-10px",
          },
        },
      },
    },
  });

  return (
    <>
      <div
        className="main-box"
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <ThemeProvider theme={theme}>
          <div className="box-head-report">
            <Stack alignItems="center" direction="row">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate("/StockReport", {
                    state: {
                      calId: calId
                    }
                  });
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h4">Stock Quick Summary</Typography>
            </Stack>
            <Stack alignItems="center" direction="row">
              {
                calId > 0 ?
                  <TextField
                    disabled
                    label="Calculation Type"
                    value={CalculationTypeList?.filter((item) => item?.value == calId)[0]?.label}
                    size="small"
                    InputLabelProps={{
                      shrink: true
                    }}
                  >
                  </TextField>
                  : <></>
              }
            </Stack>
            <Stack className="btns" alignItems="center" direction="row">
              <Button onClick={handleExport} variant="contained">
                <SaveAltIcon sx={{ fontSize: "16px" }} />
              </Button>
              <MRT_ToggleFiltersButton table={table} />
              <MRT_ShowHideColumnsButton table={table} />
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => (
                    exportToExcel(table.getPrePaginationRowModel().rows),
                    handleClose()
                  )}
                >
                  Download Excel
                </MenuItem>
                <MenuItem
                  onClick={() => (
                    exportToPDF(table.getPrePaginationRowModel().rows), handleClose()
                  )}
                >
                  Download PDF
                </MenuItem>
                <MenuItem onClick={() => (exportToJson(), handleClose())}>
                  Download JSON
                </MenuItem>
              </Menu>
            </Stack>
          </div>
          <MRT_TableContainer table={table} />
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MaterialReactTable table={table} />
          </LocalizationProvider> */}
        </ThemeProvider>
      </div>

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
